import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PhoneForm from './components/PhoneForm';
import ChatPage from './components/ChatPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PhoneForm />} />
        <Route path="/chat/:phoneno" element={<ChatPage />} />
      </Routes>
    </BrowserRouter>
  );
}
